<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/hello' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户权限管理</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card style="margin-top:15px;">
      <el-form
        ref="queryForm"
        :model="userSearchData"
        size="small"
        :inline="true"
        label-width="68px"
      >
        <el-form-item label="用户名" prop="user_name">
          <el-input
            v-model="userSearchData.user_name"
            placeholder="请输入用户名"
            clearable
            style="width: 150px"
          />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select
            v-model="userSearchData.status"
            clearable
            style="width: 150px"
          >
            <el-option label="正常" value="1" />
            <el-option label="停用" value="0" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="getUserList()"
            >搜索</el-button
          >
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-plus"
            @click="adddialogVisible = true"
            >添加</el-button
          >
        </el-form-item>
      </el-form>
      <!-- 表格 -->
      <el-table v-loading="pageloading" border :data="versionListData" stripe style="width: 100%">
        <el-table-column prop="Id" label="ID" width="80">
        </el-table-column>
        <el-table-column prop="user_id" label="用户id" width="80">
        </el-table-column>
        <el-table-column prop="user_name" label="用户名" width="100">
        </el-table-column>
        <el-table-column label="状态" width="80">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.status ? '正常' : '已停用'"
              placement="top"
              :enterable="false"
            >
              <el-switch
                v-model="scope.row.status"
                active-color="#409EFF"
                inactive-color="#ff4949"
                @change="editStatus(scope.row)"
              >
              </el-switch>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="role_id" label="角色ID" width="80">
        </el-table-column>
        <el-table-column prop="role_name" label="角色名称" width="80">
        </el-table-column>
        <el-table-column prop="app_id" label="应用名称" width="80">
          <template slot-scope="scope">
            {{
              getAppName(scope.row.app_id)
            }}
          </template>
        </el-table-column>
        <el-table-column prop="channel_id" label="版本渠道名称" width="100">
          <template slot-scope="scope">
            {{
              getChannelName(scope.row.channel_id)
            }}
          </template>
        </el-table-column> 
        <el-table-column prop="info_show_type" label="用户信息显示类型" width="100">
            <template slot-scope="scope">
            {{ scope.row.info_show_type == 0 ? "全部显示" : ""}}
            {{ scope.row.info_show_type == 1 ? "用户名和手机号部分显示" : ""}}
            {{ scope.row.info_show_type == 2 ? "用户名和手机号部分不显示" : ""}}
            </template>
        </el-table-column>
        <el-table-column prop="write_type" label="可操作类型" width="100">
            <template slot-scope="scope">
            {{ scope.row.write_type == 0 ? "能够增加和修改" : ""}}
            {{ scope.row.write_type == 1 ? "不能增加和修改" : ""}}
            </template>
        </el-table-column>  
        <el-table-column prop="create_time" label="创建时间"> </el-table-column>
        <el-table-column prop="update_time" label="更改时间"> </el-table-column>
        <el-table-column fixed="right" label="操作" width="300">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-edit"
              size="mini"
              @click="opendialog(scope.row)"
              :v-hasMenu="btnRole"
              >编辑</el-button
            >
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="deleteUser(scope.row)"
              >删除</el-button
            >
            <el-button
              type="warning"
              icon="el-icon-setting"
              size="mini"
              @click="egitRoles(scope.row)"
              >分配角色</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页功能 -->
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 50, 100, 200]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
    </el-card>
    <!-- 添加用户弹窗 -->
    <el-dialog title="添加用户" :visible.sync="adddialogVisible" width="40%">
      <el-form
        :model="adduserForm"
        :rules="addusers"
        ref="adduserForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="用户ID" prop="user_id">
          <el-input v-model="adduserForm.user_id"></el-input>
        </el-form-item>
        <el-form-item label="用户名" prop="user_name">
          <el-input v-model="adduserForm.user_name"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="user_password">
          <el-input v-model="adduserForm.user_password"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="adduserForm.email"></el-input>
        </el-form-item>
        <el-form-item label="业务员ID" prop="salesman_id">
          <el-input v-model="adduserForm.salesman_id"></el-input>
        </el-form-item>        
        <el-form-item label="App类型">
            <el-select placeholder="请选择App类型"  v-model="adduserForm.app_id">
                <el-option
                  v-for="item in appids"
                  :key="item.app_id"
                  :label="item.name"
                  :value="item.app_id">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="渠道类型">
            <el-select placeholder="请选择渠道类型"  v-model="adduserForm.channel_id">
                <el-option
                  v-for="item in channelids"
                  :key="item.channel_id"
                  :label="item.name"
                  :value="item.channel_id">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="用户状态" prop="status">
          <el-radio-group v-model="adduserForm.status">
            <el-radio label="0">不可使用</el-radio>
            <el-radio label="1">可使用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="用户信息显示类型" prop="info_show_type">
          <el-radio-group v-model="adduserForm.info_show_type">
            <el-radio label="0">全部显示</el-radio>
            <el-radio label="1">用户名和手机号部分显示</el-radio>
            <el-radio label="2">用户名和手机号部分不显示</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="可操作类型" prop="write_type">
          <el-radio-group v-model="adduserForm.write_type">
            <el-radio label="0">能够增加和修改</el-radio>
            <el-radio label="1">不能增加也不能修改</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addsubmitForm('adduserForm')"
            >确定</el-button
          >
          <el-button @click="addresetForm('adduserForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 添加用户弹窗 -->

    <!-- 编辑角色弹框 -->
    <el-dialog title="编辑用户" :visible.sync="editdialogVisible" width="40%">
      <el-form
        :model="edituserForm"
        :rules="editusers"
        ref="edituserForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="用户名" prop="user_name">
          <el-input v-model="edituserForm.user_name"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="user_password">
          <el-input v-model="edituserForm.user_password"></el-input>
        </el-form-item>
        <el-form-item label="业务员ID" prop="salesman_id">
          <el-input v-model="edituserForm.salesman_id"></el-input>
        </el-form-item>
        <el-form-item label="App类型">
            <el-select placeholder="请选择App类型"  v-model="edituserForm.app_id">
                <el-option
                  v-for="item in appids"
                  :key="item.app_id"
                  :label="item.name"
                  :value="item.app_id">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="渠道类型">
            <el-select placeholder="请选择渠道类型"  v-model="edituserForm.channel_id">
                <el-option
                  v-for="item in channelids"
                  :key="item.channel_id"
                  :label="item.name"
                  :value="item.channel_id">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="用户状态" prop="status">
          <el-radio-group v-model="edituserForm.status">
            <el-radio :label="0">不可使用</el-radio>
            <el-radio :label="1">可使用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="用户信息显示类型" prop="info_show_type">
          <el-radio-group v-model="edituserForm.info_show_type">
            <el-radio :label="0">全部显示</el-radio>
            <el-radio :label="1">用户名和手机号部分显示</el-radio>
            <el-radio :label="2">用户名和手机号部分不显示</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="可操作类型" prop="write_type">
          <el-radio-group v-model="edituserForm.write_type">
            <el-radio :label="0">能够增加和修改</el-radio>
            <el-radio :label="1">不能增加也不能修改</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="editsubmitForm('edituserForm')"
            >确定</el-button
          >
          <el-button @click="editresetForm('edituserForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 编辑角色弹框 -->

    <!-- 分配角色弹框 -->
    <el-dialog title="分配角色" :visible.sync="dialogDbtFormVisible">
      <el-form :model="rolesFrom">
        <el-form-item label="当前的用户:">{{
          rolesFrom.user_name
        }}</el-form-item>
        <el-form-item label="当前的角色:"
          >{{ rolesFrom.old_role_id }}
        </el-form-item>
        <el-form-item label="分配新角色">
          <el-select v-model="rolesFrom.role_id" placeholder="请选择">
            <el-option
              v-for="item in roleNameData"
              :key="item.role_id"
              :value="item.role_id"
              :label="item.role_name"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogDbtFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="editUseresRid">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 分配角色弹框 -->
  </div>
</template>

<script>
import { getCookie, isString } from '../../utils/util';
import { getcurrentTime, ConvertArray } from "@/utils/public";
export default {
  data() {
    return {
      pageloading: false,
      editpageloading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0, //请求列表的总条数
      btnRole: getCookie("role_id"),
      userSearchData: {
        user_name: "",
        status: ""
      },
      //添加用户
      adddialogVisible: false,
      adduserForm: {
        user_name: "",
        user_password: "",
        user_id: 0,
        email: "",
        create_time: "",
        salesman_id: "",
        app_id: 0,
        channel_id: 0,
        info_show_type: 0,
        write_type: 0
      },
      addusers: {
        user_name: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        user_password: [
          { required: true, message: "请输入密码", trigger: "blur" }
        ]
      },
      //编辑用户
      editdialogVisible: false,
      edituserForm: {
        id: 0,
        user_name: "",
        user_password: "",
        user_id: 0,
        email: "",
        update_time: "",
        salesman_id: "",
        app_id: 0,
        channel_id: 0,
        info_show_type: 0,
        write_type: 0
      },
      editusers: {
        user_name: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        user_password: [
          { required: true, message: "请输入密码", trigger: "blur" }
        ]
      },
      //   分配权限数据
      dialogDbtFormVisible: false,
      rolesList: [],
      roleNameData: [],
      tableData: [],
      versionListData: [],
      appids: [],
      channelids: [],
      rolesFrom: {
        user_name: "",
        old_role_id: "",
        role_id: ""
      }
    };
  },

  mounted() {
    this.searchAllAppidsData();
    this.searchChannelIdsData();
    this.getUserList();
    this.getRolesList();
  },

  methods: {
    getAppName(item) {
      var string = ``;
      if (item != null && this.appids != null) {
        for(var i=0; i<this.appids.length; i++) {
          var itemObject = this.appids[i];
          if (itemObject.app_id == item) {
            string = itemObject.name;
            break;
          }
        }
      }
      return string;
    },
    async searchAllAppidsData() {
      this.$axios
      .post("/3699BIApi/AppId/SearchAllData", {})
      .then(res => {
        if (res.data.code == 200) {
          var array = res.data.list;
          var resultData = [];
          var fob = new Object();
          fob["app_id"] = "";
          fob["name"] = "不选择";
          resultData.push(fob);
          for(var i = 0; i < array.length; i++) {
            let itemObject = array[i];
            var ob = new Object();
            for(var k in itemObject) {
                ob[k] = itemObject[k];
            }
            resultData.push(ob);
          }
          this.appids = resultData;
        }
      });
    },
    getChannelName(item) {
      var string = ``;
      if (isString(item)) {
        for(var i=0; i<this.channelids.length; i++) {
          var itemObject = this.channelids[i];
          if (itemObject.channel_id == item) {
            string = itemObject.name;
            break;
          }
        }
      }      
      return string;
    },
    async searchChannelIdsData() {
      this.$axios
      .post("/3699BIApi/ChannelId/SearchAllData", {})
      .then(res => {
        if (res.data.code != 200) {
          this.$message.error(`查询失败:${res.data.msg}`);
          return;
        }
        var array = res.data.list;
        var resultData = [];
        var fob = new Object();
        fob["channel_id"] = "";
        fob["name"] = "不选择";
        resultData.push(fob);
        for(var i = 0; i < array.length; i++) {
          let itemObject = array[i];
          var ob = new Object();
          for(var k in itemObject) {
              ob[k] = itemObject[k];
          }
          resultData.push(ob);
        }
        this.channelids = resultData;
      });
    },
    // 获取用户列表
    async getUserList() {
      this.pageloading = true;
      await this.$axios.post("/3699BIApi/AdminUser/SearchData", {
            user_name: this.userSearchData.user_name,
            status: Number.parseInt(this.userSearchData.status),
            currentPage: this.currentPage,
            pageSize: this.pageSize
      }).then(res => {
        // console.log(res);
        if (res.data.code == 200) {
          // this.$message.success("获取用户数据成功");
          res.data.list.forEach(value => {
            if (value.status == 1) {
              value.status = true;
            } else {
              value.status = false;
            }
          });
          this.pageloading = false;
          this.tableData = res.data.list;
          this.total = res.data.total;
          this.updateCurrpageData();
          // console.log(this.userListData);
        }
      });
    },
    // 添加用户方法
    addsubmitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.adduserForm.create_time = getcurrentTime();
          this.adduserForm.status = 1;
          this.$axios.post("/3699BIApi/AdminUser/AddData", {
              user_name: this.adduserForm.user_name,
              user_password: this.adduserForm.user_password,
              user_id: Number.parseInt(this.adduserForm.user_id),
              email: this.adduserForm.email,
              salesman_id: Number.parseInt(this.adduserForm.salesman_id),
              app_id: Number.parseInt(this.adduserForm.app_id),
              channel_id: Number.parseInt(this.adduserForm.channel_id),
              info_show_type: Number.parseInt(this.adduserForm.info_show_type),
              write_type: Number.parseInt(this.adduserForm.write_type)
          }).then(res => {
            // console.log(res);
            if (res.data.code == 200) {
              this.$message.success("添加用户成功");
              this.getUserList();
              this.adddialogVisible = false;
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    addresetForm(formName) {
      this.$refs[formName].resetFields();
      this.adddialogVisible = false;
      this.adduserForm = {
        user_name: "",
        user_password: "",
      };
    },
    // 编辑用户方法
    opendialog(row) {
      this.editdialogVisible = true;
      // console.log(row);
      this.edituserForm = {
        id: row.Id,
        user_name: row.user_name,
        user_password: row.user_password,
        status: row.status,
        user_id: row.user_id,
        salesman_id: row.salesman_id,
        app_id: row.app_id,
        channel_id: row.channel_id,
        info_show_type: row.info_show_type,
        write_type: row.write_type
      };
    },
    editsubmitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.edituserForm.update_time = getcurrentTime();
          this.$axios
            .post("/3699BIApi/AdminUser/UpdateData", {
                id: Number.parseInt(this.edituserForm.id),
                user_name: this.edituserForm.user_name,
                user_password: this.edituserForm.user_password,
                user_id: Number.parseInt(this.edituserForm.user_id),
                email: this.edituserForm.email,
                salesman_id: Number.parseInt(this.edituserForm.salesman_id),
                app_id: Number.parseInt(this.edituserForm.app_id),
                channel_id: Number.parseInt(this.edituserForm.channel_id),
                info_show_type: Number.parseInt(this.edituserForm.info_show_type),
                write_type: Number.parseInt(this.edituserForm.write_type)
            })
            .then(res => {
              console.log(res);
              if (res.status == 200) {
                this.editdialogVisible = false;
                this.$message.success("编辑成功");
                this.getUserList();
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    editresetForm(formName) {
      this.$refs[formName].resetFields();
      this.editdialogVisible = false;
      this.edituserForm = {
        user_name: "",
        user_password: "",
        email: ""
      };
    },
    // 删除用户方法
    async deleteUser(row) {
      var itemId = Number.parseInt(row.Id)
      await this.$axios
        .post("/3699BIApi/AdminUser/DeleteData", { id: itemId })
        .then(res => {
          console.log(res);
          if (res.data.code == 200) {
            this.$message.success("删除用户成功");
            this.getUserList();
          }
        });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getUserList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getUserList();
    },
    updateCurrpageData() {
        var arrays = [];
        var i = 0;
        var endi = this.total - this.pageSize * (this.currentPage-1);
        if (endi > this.pageSize) {
          endi = this.pageSize;
        }
        console.log(`updateCurrpageData ${endi} 条`);
        for(; i<endi; i++) {
          if (i < this.total) {
            var itemObject = this.tableData[i];
            arrays.push(itemObject);
          }
        }
        
        this.versionListData = arrays.filter(val => {
          return val;
        });
      },
    // 改变用户状态
    async editStatus(row) {
      let status = 0;
      let user_id = row.user_id;
      if (row.status) {
        status = 1;
      } else {
        status = 0;
      }
      status = Number.parseInt(status)
      // console.log(status, user_id);
      await this.$axios
        .post("/3699BIApi/AdminUser/UpdateStatus", { user_id, status })
        .then(res => {
          // console.log(res);
          if (res.data.code == 200) {
            this.$message.success("修改状态成功");
          } else {
            this.$message.error("修改状态失败");
          }
        });
    },
    // 分配角色方法
    egitRoles(row) {
      this.dialogDbtFormVisible = true;
      this.user_id = row.user_id;
      this.rolesFrom = {
        user_name: row.user_name,
        old_role_id: row.role_name,
        role_id: ""
      };
      // console.log(this.rolesFrom,this.user_id);
    },
    async editUseresRid() {
      // 判断选择角色表单是否为空
      if (this.rolesFrom.role_id.length == 0 || this.rolesFrom.role_id == "") {
        return this.$message.warning("请选择要分配的新角色");
      }
      // 判断角色是否与已选择的角色重复
      if (this.rolesFrom.role_id == this.rolesFrom.old_role_id) {
        return this.$message.warning("当前角色已存在,请选择其他角色");
      } else {
        // console.log(this.rolesFrom, this.user_id);
        await this.$axios
          .post("/3699BIApi/AdminUser/UpdateRoleData", {
            user_id: this.user_id,
            role_id: this.rolesFrom.role_id
          })
          .then(res => {
            console.log(res);
            if (res.data.code == 200) {
              this.$message.success("分配角色成功");
              this.dialogDbtFormVisible = false;
              this.getUserList();
            }
          });
      }
    },
    getRoleName(item) {
      var string = ``;
      if (isString(item)) {
        for (var i = 0; i < this.roleslist.length; i++) {
          var itemObject = this.appids[i];
          if (itemObject.role_name == item) {
            string = itemObject.role_name;
            break;
          }
        }
      }
      return string;
    },
    // 获取角色列表的数据
    async getRolesList() {
      this.$axios.post("/3699BIApi/AdminRole/AllChildren", {}).then(res => {
        if (res.data.code == 200) {
          res.data.list.forEach(value => {
            value.children = ConvertArray(value.children);
          });
        }
        this.roleNameData = res.data.list;
      });
    }
  }
};
</script>

<style lang="sass" scoped></style>



// WEBPACK FOOTER //
// src/views/AdminManager/AdminUserManager.vue